import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Component, inject, OnInit } from '@angular/core';
import { AuthService, BaseViewConfigService, GungFlowService, GungNavbarComponent, MetadataService, NavbarCartService } from 'gung-standard';
import { takeUntil } from 'rxjs';
import { SjoborgNavbarService } from '../../services/sjoborg-navbar.service';
import { Router } from '@angular/router';

@Component({
    selector: 'sjoborg-navbar',
    templateUrl: './sjoborg-navbar.component.html',
    styleUrls: ['./sjoborg-navbar.component.scss'],
    standalone: false
})
export class SjoborgNavbarComponent extends GungNavbarComponent implements OnInit {
  protected gungNavbar = inject(SjoborgNavbarService);


  ngOnInit(): void {
    super.ngOnInit();
    this.breakpointObserver
      .observe(['(max-width: 768px)'])
      .subscribe((state: BreakpointState) => {

        this.mobileDevice = state.matches;

        this.gungNavbar.getShopMenu(this.mobileDevice).pipe(takeUntil(this.unsubscribe)).subscribe(shopMenu => {
          this.shopMenu = shopMenu;
        });
      });
  }
}
